// extracted by mini-css-extract-plugin
export default {"checkbox-modal":"InputEditWarningModal_checkbox-modal__prskQ","save":"InputEditWarningModal_save__Oyo07","cancel":"InputEditWarningModal_cancel__BX6wd"};